module.exports = __webpack_public_path__ + "static/OwenKeehnen_Headshot-199c0d64b035ae9f9e3ff2ef91627a8e.png";